export default "__VITE_ASSET__G4NwC7VO__"